var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.5,
    fill: "url(#paint0_linear_5065_3485)",
    stroke: "#234B9E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5065_3485)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1114 13.8893H6.88916V13.1115C6.88916 12.5958 7.09402 12.1013 7.45867 11.7366C7.82333 11.372 8.31791 11.1671 8.8336 11.1671H11.1669C11.6826 11.1671 12.1772 11.372 12.5419 11.7366C12.9065 12.1013 13.1114 12.5958 13.1114 13.1115V13.8893ZM10.0003 10.3893C9.69385 10.3893 9.39044 10.329 9.10734 10.2117C8.82425 10.0944 8.56703 9.92257 8.35036 9.70591C8.13369 9.48924 7.96181 9.23201 7.84455 8.94892C7.72729 8.66582 7.66694 8.36241 7.66694 8.05599C7.66694 7.74957 7.72729 7.44615 7.84455 7.16306C7.96181 6.87997 8.13369 6.62274 8.35036 6.40607C8.56703 6.1894 8.82425 6.01753 9.10734 5.90027C9.39044 5.78301 9.69385 5.72266 10.0003 5.72266C10.6191 5.72266 11.2126 5.96849 11.6502 6.40607C12.0878 6.84366 12.3336 7.43715 12.3336 8.05599C12.3336 8.67483 12.0878 9.26832 11.6502 9.70591C11.2126 10.1435 10.6191 10.3893 10.0003 10.3893Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5065_3485",
    x1: 10,
    y1: 0,
    x2: 10,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5065_3485"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.33333,
    height: 9.33333,
    fill: "white",
    transform: "translate(5.3335 5.33398)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profile-icon.ee2c867123ca009a119b2a8c3923da85.svg";
export { ForwardRef as ReactComponent };